const currencies = [
  { currency: 'USD', name: 'US Dollar' },
  { currency: 'AED', name: 'UAE Dirhams' },
  { currency: 'EUR', name: 'Euro' },
  { currency: 'INR', name: 'Indian RUPEE' },
  { currency: 'BRL', name: 'Brazilian Real' }
];

export default currencies;
